import PropTypes from 'prop-types';

export function FreeShippingThresholdWithBgIcon({ className, width }) {
    return (
        <svg
            width={width}
            height={width}
            className={className}
            viewBox="0 0 51 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M29.5216 48.0643C41.7662 42.2635 52.8223 32.0855 50.0771 18.8165C47.332 5.54739 34.8922 -0.311051 19.5787 0.0126932C6.03464 0.305393 0.0475901 14.5634 0.526554 29.0077C0.974474 42.5518 17.8446 53.5945 29.5216 48.0643Z"
                className="fill-[#B0C372] if:fill-[#F0D3E3]"
            />
            <path
                d="M34.3797 37.8226L8.83398 36.681L10.6065 9.30811L36.1522 10.4497L34.3797 37.8226Z"
                fill="white"
                stroke="#2D2D2D"
                strokeWidth="1.17783"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M43.7591 39.7709L34.3789 37.8231L36.1514 10.4502L45.5317 12.3908L43.7591 39.7709Z"
                fill="#F2D79A"
                stroke="#2D2D2D"
                strokeWidth="1.17783"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M8.83398 36.6812V37.3161L21.6671 39.0998L43.7599 40.3841V39.7705L34.3797 37.8227L8.83398 36.6812Z"
                fill="#2D2D2D"
            />
            <path
                d="M35.0602 7.40471L22.4114 30.317C22.3126 30.5619 22.1481 30.7743 21.9364 30.9306C21.3975 31.2731 20.7311 30.8093 20.2631 30.3741L13.4141 24.0028C13.4141 24.0028 14.0025 21.2417 14.8321 21.5057C15.6616 21.7697 20.3269 26.7069 20.5964 25.9863C20.8658 25.2657 31.1677 4.90757 32.1391 5.00032C33.1104 5.09307 35.0602 7.40471 35.0602 7.40471Z"
                className="fill-[#B0C372] if:fill-[#E95CA2]"
                stroke="#2D2D2D"
                strokeWidth="1.17783"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}

FreeShippingThresholdWithBgIcon.propTypes = {
    className: PropTypes.string,
    width: PropTypes.number,
};

FreeShippingThresholdWithBgIcon.defaultProps = {
    className: null,
    width: 24,
};
